
class ContactAuthor
{
	/** @type {PopupHelper} */
	_popupHelper = null;

	constructor()
	{
		console.log('executing contactauthor.ctor');
		let thisObj = this;
		this._popupHelper = new PopupHelper("#email-author-popup", {
			popupOKCallback: thisObj._submitRequest.bind(thisObj),
			resetFieldsCallback: thisObj._resetFields.bind(thisObj),
		});
	}

	open(endpoint)
	{
		this._popupHelper.open(endpoint);
	}

	_resetFields()
	{
		const $subject = $(`${this._popupHelper.containerSelector} #email-subject`);
		const $body = $(`${this._popupHelper.containerSelector} #email-body`);
		$subject.val($subject.attr("default"));
		$body.prop("data-froala.editor").html.set("");
	}

	_submitRequest(endpoint)
	{
		const popupHelper = this._popupHelper;
		const $subject = $(`${this._popupHelper.containerSelector} #email-subject`);
		const $body = $(`${this._popupHelper.containerSelector} #email-body`);
		const data = {
			subject: $subject.val(),
			body: $body.prop("data-froala.editor").html.get(),
		};
		popupHelper.showLoading();

		dataAction.callClientPostEndpoint(
			endpoint,
			data,
			function (response)
			{
				popupHelper.close();
				showSuccessPopup(response);
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}
}